// extracted by mini-css-extract-plugin
export default {"container":"Qg-z","bubbleNav":"Rg-z","graphic":"Sg-z","contact":"Tg-z"};